import MainLayout from 'layout/MainLayout.tsx';
import Lazy from 'components/Lazy.tsx';
import { lazy } from 'react';
import lazyRetry from './lazyLoader';

const BatchJobView = Lazy(lazy(() => lazyRetry(() => import('views/batch-jobs/BatchJobsView.tsx'))));
const BatchJobAddView = Lazy(lazy(() => lazyRetry(() => import('views/batch-jobs/BatchJobAdd'))));
const BatchJobEditView = Lazy(lazy(() => lazyRetry(() => import('views/batch-jobs/BatchJobEdit.tsx'))));

const ProjectBatchJobsRoutes = {
  path: '/projects/:projectId/batch-jobs/',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <BatchJobView />,
    },
    {
      path: 'add/',
      element: <BatchJobAddView />,
    },
    {
      path: 'edit/:batchJobId',
      element: <BatchJobEditView />,
    },
  ],
};

export default ProjectBatchJobsRoutes;
